// Module
var code = `<dialog class="dialog-syzkaller">
    <h3>syzkaller programs</h3>
    <div class="syzkaller-programs"></div>
    <form method="dialog"><input type=submit value="close"></form>
</dialog>`;
// Exports
export default code;